<script lang="ts" setup>
import { defineComponent, onMounted } from "vue";
import { GlobalSnackbar } from "@/modules/globalSnackbar";
import { useAuthStore } from "@/store/auth.store";
import { useRoute } from "vue-router";
import { RouteNames } from "@/router/routes";

defineComponent({
  name: "EmptyLayout",
});

const route = useRoute();

const { fetchUserProfile } = useAuthStore();

onMounted(async () => {
  if (route.name !== RouteNames.LOGIN_VIEW) {
    await fetchUserProfile();
  }
});
</script>

<template>
  <div class="login-layout">
    <RouterView />
    <GlobalSnackbar />
  </div>
</template>

<style lang="scss" scoped>
.login-layout {
  height: 100%;
  background: var(--color-semantic-background-normal-bg-secondary);
}
</style>
